// // ------------------- Library Imports -------------------
// import { Menu } from "antd";
// import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

// // ------------------- Sidebar Menu Item Icons -------------------
// import Tounemtimage from "../../assets/images/sidebar/tounament-icon.svg";
// import StoreIcon from "../../assets/images/sidebar/stores-icon.svg";
// import LiveStreamIcon from "../../assets/images/sidebar/live-stream-icon.svg";
// import AuctionsIcon from "../../assets/images/sidebar/auction-icon.svg";
// import PodcastIcon from "../../assets/images/sidebar/podcast-icon.svg";
// import ForumIcon from "../../assets/images/sidebar/comunnity-icon.svg";
// import ProfileIcon from "../../assets/images/sidebar/profile-icon.svg";
// import HelpIcon from "../../assets/images/sidebar/help-icon.svg";
// import FAQIcon from "../../assets/images/sidebar/faq-icon.svg";
// import AboutIcon from "../../assets/images/sidebar/about.svg";
// import PasttunamentIcon from "../../assets/images/sidebar/past-turnament.svg";
// import privatetunamentIcon from "../../assets/images/sidebar/private-lock-icon.svg";
// import UpcomingIcon from "../../assets/images/sidebar/upcoming-icon.svg";
// import CurrenttunamentIcon from "../../assets/images/sidebar/curreent-tunament-icon.svg";
// import GuidelineTutorialsIcon from "../../assets/images/sidebar/guideline-tutorials-icon.svg";

// // ------------------- Other Asset Imports -------------------
// import SuggestionIcon from "../../assets/images/sidebar/sugesstion-icon.svg";
// import ComplianceIcon from "../../assets/images/sidebar/compliance-icon.svg";
// import ContactIcon from "../../assets/images/sidebar/contact-icon.svg";
// import RedBullLogo from "../../assets/images/sidebar/redbull-image.svg";
// import ArrowsquareLeft from "../../assets/images/arrow-square-left.svg";

// // ------------------- Social Media Icons -------------------
// import YouTubeIcon from "../../assets/images/sidebar/youtube-image.svg";
// import TwitchIcon from "../../assets/images/sidebar/chat-image.svg";
// import XIcon from "../../assets/images/sidebar/x-image.svg";
// import TelegramIcon from "../../assets/images/sidebar/telegram-image.svg";
// import InstagramIcon from "../../assets/images/sidebar/insta-image.svg";
// import KickIcon from "../../assets/images/sidebar/k-image.svg";
// import FacebookIcon from "../../assets/images/sidebar/facebook-image.svg";
// import TikTokIcon from "../../assets/images/sidebar/tiktok-image.svg";
// import { useEffect, useState } from "react";

// const { SubMenu } = Menu;

// function Sidenav({ collapsed, setCollapsed }) {
//   const location = useLocation();
//   const [openKeys, setOpenKeys] = useState(["tournaments"]);
//   const currentPath = location.pathname;

//   // ------------ Handlers ---------------

//   const onOpenChange = (keys) => {
//     setOpenKeys(keys.length ? [keys[keys.length - 1]] : []);
//   };

//   const handleMenuClick = (e) => {
//     if (e.keyPath.length === 1) {
//       setOpenKeys([]);
//     }
//   };

//   useEffect(() => {
//     if (currentPath.includes("tournaments")) {
//       setOpenKeys(["tournaments"]);
//     } else if (
//       currentPath.includes("guideline-tutorials") ||
//       currentPath.includes("faqandterms") ||
//       currentPath.includes("suggestion") ||
//       currentPath.includes("compliance") ||
//       currentPath.includes("contact")
//     ) {
//       setOpenKeys(["help"]);
//     } else {
//       setOpenKeys([]);
//     }
//   }, [currentPath]);

//   return (
//     <div
//       className="main-new-side-main-tio"
//       style={{
//         width: collapsed ? "60px" : "215px",
//         transition: "width 0.3s ease",
//       }}
//     >
//       <div
//         className="menu-side-bar-header"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         {!collapsed && <h4>Menu</h4>}
//         <img
//           src={ArrowsquareLeft}
//           onClick={() => setCollapsed(!collapsed)}
//           style={{
//             cursor: "pointer",
//             transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
//             transition: "transform 0.3s ease",
//           }}
//           alt="Toggle Sidebar"
//         />
//       </div>

//       <Menu
//         theme="dark"
//         mode="inline"
//         openKeys={openKeys}
//         onOpenChange={onOpenChange}
//         onClick={handleMenuClick}
//         inlineCollapsed={collapsed}
//         style={{ flexGrow: 1, borderRight: 0 }}
//       >
//         <SubMenu
//           key="tournaments"
//           icon={<img src={Tounemtimage} alt="Tournaments" />}
//           title="Tournaments"
//           // onTitleClick={() => navigate("/lobby-tournaments")}
//         >
//           <Menu.Item
//             key="current"
//             className={
//               currentPath.startsWith("/live-tournaments") ? "active" : ""
//             }
//             icon={<img src={CurrenttunamentIcon} alt="Stores" />}
//           >
//             <NavLink to="/live-tournaments">Live</NavLink>
//           </Menu.Item>
//           <Menu.Item
//             key="history"
//             className={
//               currentPath.startsWith("/upcoming-tournaments") ? "active" : ""
//             }
//             icon={<img src={UpcomingIcon} alt="Stores" />}
//           >
//             <NavLink to="/upcoming-tournaments">Upcoming</NavLink>
//           </Menu.Item>
//           <Menu.Item
//             key="private1"
//             className={
//               currentPath.startsWith("/past-tournaments") ? "active" : ""
//             }
//             icon={<img src={PasttunamentIcon} alt="Stores" />}
//           >
//             <NavLink to="/past-tournaments">Past</NavLink>
//           </Menu.Item>
//           <Menu.Item
//             key="private2"
//             className={
//               currentPath.startsWith("/private-tournaments") ? "active" : ""
//             }
//             icon={<img src={privatetunamentIcon} alt="Stores" />}
//           >
//             <NavLink to="/private-tournaments">Private</NavLink>
//           </Menu.Item>
//         </SubMenu>

//         <Menu.Item
//           key="stores"
//           className={currentPath.startsWith("/stores") ? "active" : ""}
//           icon={<img src={StoreIcon} alt="Stores" />}
//         >
//           <NavLink to="/stores">Stores</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="live-stream"
//           className={currentPath.startsWith("/live-stream") ? "active" : ""}
//           icon={<img src={LiveStreamIcon} alt="Live Stream" />}
//         >
//           <NavLink to="/live-stream">Live Stream</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="auctions"
//           className={currentPath.startsWith("/auctions") ? "active" : ""}
//           icon={<img src={AuctionsIcon} alt="Auctions" />}
//         >
//           <NavLink to="/auctions">Auctions</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="podcasts"
//           className={currentPath.startsWith("/podcasts") ? "active" : ""}
//           icon={<img src={PodcastIcon} alt="Podcasts" />}
//         >
//           <NavLink to="/podcasts">Podcasts</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="forums"
//           className={currentPath.startsWith("/forums") ? "active" : ""}
//           icon={<img src={ForumIcon} alt="Forums" />}
//         >
//           <NavLink to="/forums">Forums & Community</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="profile"
//           className={currentPath === "/profile" ? "active" : ""}
//           icon={<img src={ProfileIcon} alt="Profile" />}
//         >
//           <NavLink to="/profile">Profile</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="about"
//           className={currentPath === "/about-leaderboard" ? "active" : ""}
//           icon={<img src={AboutIcon} alt="about" />}
//         >
//           <NavLink to="/about-leaderboard">About Leaderboard</NavLink>
//         </Menu.Item>

//         <Menu.Item
//           key="settings"
//           className={currentPath === "/settings" ? "active" : ""}
//           icon={<img src={AboutIcon} alt="settings" />}
//         >
//           <NavLink to="/settings">Settings</NavLink>
//         </Menu.Item>

//         <SubMenu
//           key="help"
//           icon={<img src={HelpIcon} alt="Help" />}
//           title="Help"
//         >
//           <Menu.Item
//             key="guideline-tutorials"
//             icon={
//               <img src={GuidelineTutorialsIcon} alt="guideline-tutorials" />
//             }
//             className={currentPath === "/guideline-tutorials" ? "active" : ""}
//           >
//             <NavLink to="/guideline-tutorials">Guideline Tutorials</NavLink>
//           </Menu.Item>

//           <Menu.Item
//             key="faq"
//             icon={<img src={FAQIcon} alt="FAQ" />}
//             className={currentPath === "/faqandterms" ? "active" : ""}
//           >
//             <NavLink to="/faqandterms">FAQ & Terms</NavLink>
//           </Menu.Item>

//           <Menu.Item
//             key="suggestions"
//             icon={<img src={SuggestionIcon} alt="Suggestions" />}
//             className={currentPath === "/suggestion" ? "active" : ""}
//           >
//             <NavLink to="/suggestion">Suggestions</NavLink>
//           </Menu.Item>

//           <Menu.Item
//             key="compliance"
//             icon={<img src={ComplianceIcon} alt="Compliance" />}
//             className={currentPath === "/compliance" ? "active" : ""}
//           >
//             <NavLink to="/compliance">Compliance</NavLink>
//           </Menu.Item>

//           <Menu.Item
//             key="contact"
//             icon={<img src={ContactIcon} alt="Contact" />}
//             className={currentPath === "/contact" ? "active" : ""}
//           >
//             <NavLink to="/contact">Contact</NavLink>
//           </Menu.Item>
//         </SubMenu>
//       </Menu>

//       {!collapsed && (
//         <div className="sonser-and-socialmedia-icon-main">
//           <div className="sponserd-by-flag">
//             <h5>Sponsored By</h5>
//             <img src={RedBullLogo} alt="Red Bull" />
//           </div>

//           <div>
//             <Link
//               to="/terms-and-condition"
//               style={{ color: "#999", fontSize: "12px" }}
//             >
//               View Our <span>Terms & Conditions</span>
//             </Link>
//           </div>

//           <div className="social-side-image">
//             <Link to={"https://www.youtube.com/"}>
//               <img src={YouTubeIcon} alt="YouTube" />
//             </Link>
//             <Link to={"https://www.twitch.tv"}>
//               <img src={TwitchIcon} alt="Twitch" />
//             </Link>
//             <Link to={"https://x.com/"}>
//               <img src={XIcon} alt="X" />
//             </Link>
//             <Link to={"https://web.telegram.org"}>
//               <img src={TelegramIcon} alt="Telegram" />
//             </Link>
//             <Link to={"https://www.instagram.com"}>
//               <img src={InstagramIcon} alt="Instagram" />
//             </Link>
//             <Link to={"https://kick.com"}>
//               <img src={KickIcon} alt="Kick" />
//             </Link>
//             <Link to={"https://www.facebook.com"}>
//               <img src={FacebookIcon} alt="Facebook" />
//             </Link>
//             <Link to={"https://www.tiktok.com/en"}>
//               <img src={TikTokIcon} alt="TikTok" />
//             </Link>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Sidenav;

// ------------------- Library Imports -------------------
import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";

// ------------------- Sidebar Menu Item Icons -------------------
import Tounemtimage from "../../assets/images/sidebar/tounament-icon.svg";
import StoreIcon from "../../assets/images/sidebar/stores-icon.svg";
import LiveStreamIcon from "../../assets/images/sidebar/live-stream-icon.svg";
import AuctionsIcon from "../../assets/images/sidebar/auction-icon.svg";
import PodcastIcon from "../../assets/images/sidebar/podcast-icon.svg";
import ForumIcon from "../../assets/images/sidebar/comunnity-icon.svg";
import ProfileIcon from "../../assets/images/sidebar/profile-icon.svg";
import HelpIcon from "../../assets/images/sidebar/help-icon.svg";
import FAQIcon from "../../assets/images/sidebar/faq-icon.svg";
import AboutIcon from "../../assets/images/sidebar/about.svg";
import PasttunamentIcon from "../../assets/images/sidebar/past-turnament.svg";
import privatetunamentIcon from "../../assets/images/sidebar/private-lock-icon.svg";
import UpcomingIcon from "../../assets/images/sidebar/upcoming-icon.svg";
import CurrenttunamentIcon from "../../assets/images/sidebar/curreent-tunament-icon.svg";
import GuidelineTutorialsIcon from "../../assets/images/sidebar/guideline-tutorials-icon.svg";

// ------------------- Other Asset Imports -------------------
import SuggestionIcon from "../../assets/images/sidebar/sugesstion-icon.svg";
import ComplianceIcon from "../../assets/images/sidebar/compliance-icon.svg";
import ContactIcon from "../../assets/images/sidebar/contact-icon.svg";
import RedBullLogo from "../../assets/images/sidebar/redbull-image.svg";
import ArrowsquareLeft from "../../assets/images/arrow-square-left.svg";

// ------------------- Social Media Icons -------------------
import YouTubeIcon from "../../assets/images/sidebar/youtube-image.svg";
import TwitchIcon from "../../assets/images/sidebar/chat-image.svg";
import XIcon from "../../assets/images/sidebar/x-image.svg";
import TelegramIcon from "../../assets/images/sidebar/telegram-image.svg";
import InstagramIcon from "../../assets/images/sidebar/insta-image.svg";
import KickIcon from "../../assets/images/sidebar/k-image.svg";
import FacebookIcon from "../../assets/images/sidebar/facebook-image.svg";
import TikTokIcon from "../../assets/images/sidebar/tiktok-image.svg";
import SettingIcon from "../../assets/images/sidebar/setting_icon.svg";

import { useEffect, useState } from "react";

const { SubMenu } = Menu;

function Sidenav({ color, collapsed, setCollapsed, closeDrawer , isMobile  }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [openKeys, setOpenKeys] = useState([]);
const [open, setOpen] = useState(false);

  // ---------------- FIXED HANDLER ----------------
  const onOpenChange = (keys) => {
    setOpenKeys(keys.length ? [keys[keys.length - 1]] : []);
  };

  // ---------------- FIXED MENU CLICK ----------------
  const handleMenuClick = (e) => {
    const topLevelMenuKeys = [
      "stores",
      "live-stream",
      "auctions",
      "podcasts",
      "forums",
      "profile",
      "about",
      "settings",
    ];

    // Close dropdown ONLY when clicking a top-level non-Submenu item
    if (topLevelMenuKeys.includes(e.key)) {
      setOpenKeys([]);
    }
  };

  // ---------------- AUTO OPEN ON PAGE REFRESH ----------------
  useEffect(() => {
    if (currentPath.includes("tournaments")) {
      setOpenKeys(["tournaments"]);
    } else if (
      currentPath.includes("guideline-tutorials") ||
      currentPath.includes("faqandterms") ||
      currentPath.includes("suggestion") ||
      currentPath.includes("compliance") ||
      currentPath.includes("contact")
    ) {
      setOpenKeys(["help"]);
    } else {
      setOpenKeys([]);
    }
  }, [currentPath]);

  return (
    <div
  className="main-new-side-main-tio"
  style={{
    width: isMobile ? "215px" : collapsed ? "60px" : "215px",
    transition: "width 0.3s ease",
  }}
>
      <div
        className="menu-side-bar-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {!collapsed && <h4>Menu</h4>}
<img
  src={ArrowsquareLeft}
  onClick={() => {
    if (window.innerWidth <= 991) {
      closeDrawer();   
    } else {
      setCollapsed(!collapsed);  
    }
  }}
  style={{
    cursor: "pointer",
    transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
    transition: "transform 0.3s ease",
  }}
  alt="Toggle Sidebar"
/>



      </div>

      <Menu
        theme="dark"
        mode="inline"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onClick={handleMenuClick}
        inlineCollapsed={collapsed}
        style={{ flexGrow: 1, borderRight: 0 }}
      >
        <SubMenu
          key="tournaments"
          icon={<img src={Tounemtimage} alt="Tournaments" />}
          title="Tournaments"
        >
          <Menu.Item
            key="live"
            className={
              currentPath.startsWith("/live-tournaments") ? "active" : ""
            }
            icon={<img src={CurrenttunamentIcon} alt="Live" />}
          >
            <NavLink to="/live-tournaments">Live</NavLink>
          </Menu.Item>

          <Menu.Item
            key="upcoming"
            className={
              currentPath.startsWith("/upcoming-tournaments") ? "active" : ""
            }
            icon={<img src={UpcomingIcon} alt="Upcoming" />}
          >
            <NavLink to="/upcoming-tournaments">Upcoming</NavLink>
          </Menu.Item>

          <Menu.Item
            key="past"
            className={
              currentPath.startsWith("/past-tournaments") ? "active" : ""
            }
            icon={<img src={PasttunamentIcon} alt="Past" />}
          >
            <NavLink to="/past-tournaments">Past</NavLink>
          </Menu.Item>

          <Menu.Item
            key="private"
            className={
              currentPath.startsWith("/private-tournaments") ? "active" : ""
            }
            icon={<img src={privatetunamentIcon} alt="Private" />}
          >
            <NavLink to="/private-tournaments">Private</NavLink>
          </Menu.Item>
        </SubMenu>

        {/* Top Level Items */}
        <Menu.Item
          key="stores"
          className={currentPath.startsWith("/stores") ? "active" : ""}
          icon={<img src={StoreIcon} alt="Stores" />}
        >
          <NavLink to="/stores">Stores</NavLink>
        </Menu.Item>

        <Menu.Item
          key="live-stream"
          className={currentPath.startsWith("/live-stream") ? "active" : ""}
          icon={<img src={LiveStreamIcon} alt="Live Stream" />}
        >
          <NavLink to="/live-stream">Live Stream</NavLink>
        </Menu.Item>

        <Menu.Item
          key="auctions"
          className={currentPath.startsWith("/auctions") ? "active" : ""}
          icon={<img src={AuctionsIcon} alt="Auctions" />}
        >
          <NavLink to="/auctions">Auctions</NavLink>
        </Menu.Item>

        <Menu.Item
          key="podcasts"
          className={currentPath.startsWith("/podcasts") ? "active" : ""}
          icon={<img src={PodcastIcon} alt="Podcasts" />}
        >
          <NavLink to="/podcasts">Podcasts</NavLink>
        </Menu.Item>

        <Menu.Item
          key="forums"
          className={currentPath.startsWith("/forums") ? "active" : ""}
          icon={<img src={ForumIcon} alt="Forums" />}
        >
          <NavLink to="/forums">Forums & Community</NavLink>
        </Menu.Item>

        <Menu.Item
          key="profile"
          className={currentPath === "/profile" ? "active" : ""}
          icon={<img src={ProfileIcon} alt="Profile" />}
        >
          <NavLink to="/profile">Profile</NavLink>
        </Menu.Item>

        <Menu.Item
          key="about"
          className={currentPath === "/about-leaderboard" ? "active" : ""}
          icon={<img src={AboutIcon} alt="About" />}
        >
          <NavLink to="/about-leaderboard">About Leaderboard</NavLink>
        </Menu.Item>

        <Menu.Item
          key="settings"
          className={currentPath === "/settings" ? "active" : ""}
          icon={<img src={SettingIcon} alt="Settings" />}
        >
          <NavLink to="/settings">Settings</NavLink>
        </Menu.Item>

        <SubMenu
          key="help"
          icon={<img src={HelpIcon} alt="Help" />}
          title="Help"
        >
          <Menu.Item
            key="guideline"
            className={currentPath === "/guideline-tutorials" ? "active" : ""}
            icon={<img src={GuidelineTutorialsIcon} alt="Guideline" />}
          >
            <NavLink to="/guideline-tutorials">Guideline Tutorials</NavLink>
          </Menu.Item>

          <Menu.Item
            key="faq"
            className={currentPath === "/faqandterms" ? "active" : ""}
            icon={<img src={FAQIcon} alt="FAQ" />}
          >
            <NavLink to="/faqandterms">FAQ & Terms</NavLink>
          </Menu.Item>

          <Menu.Item
            key="suggestion"
            className={currentPath === "/suggestion" ? "active" : ""}
            icon={<img src={SuggestionIcon} alt="Suggestions" />}
          >
            <NavLink to="/suggestion">Suggestions</NavLink>
          </Menu.Item>

          <Menu.Item
            key="compliance"
            className={currentPath === "/compliance" ? "active" : ""}
            icon={<img src={ComplianceIcon} alt="Compliance" />}
          >
            <NavLink to="/compliance">Compliance</NavLink>
          </Menu.Item>

          <Menu.Item
            key="contact"
            className={currentPath === "/contact" ? "active" : ""}
            icon={<img src={ContactIcon} alt="Contact" />}
          >
            <NavLink to="/contact">Contact</NavLink>
          </Menu.Item>
        </SubMenu>
      </Menu>

      {!collapsed && (
        <div className="sonser-and-socialmedia-icon-main">
          <div className="sponserd-by-flag">
            <h5>Sponsored By</h5>
            <img src={RedBullLogo} alt="Red Bull" />
          </div>

          <div>
            <Link
              to="/terms-and-condition"
              style={{ color: "#999", fontSize: "12px" }}
            >
              View Our <span>Terms & Conditions</span>
            </Link>
          </div>

          <div className="social-side-image">
            <Link to={"https://www.youtube.com/"}>
              <img src={YouTubeIcon} alt="YouTube" />
            </Link>
            <Link to={"https://www.twitch.tv"}>
              <img src={TwitchIcon} alt="Twitch" />
            </Link>
            <Link to={"https://x.com/"}>
              <img src={XIcon} alt="X" />
            </Link>
            <Link to={"https://web.telegram.org"}>
              <img src={TelegramIcon} alt="Telegram" />
            </Link>
            <Link to={"https://www.instagram.com"}>
              <img src={InstagramIcon} alt="Instagram" />
            </Link>
            <Link to={"https://kick.com"}>
              <img src={KickIcon} alt="Kick" />
            </Link>
            <Link to={"https://www.facebook.com"}>
              <img src={FacebookIcon} alt="Facebook" />
            </Link>
            <Link to={"https://www.tiktok.com/en"}>
              <img src={TikTokIcon} alt="TikTok" />
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidenav;
